import React, { useState } from 'react';
import { Clock, X, FileText } from 'lucide-react';
import ArticleContentModal from './ArticleContentModal';

export default function NewsSummaryModal({ article, onClose, onViewOriginal, userRole, onDelete }) {
  const [showFullArticle, setShowFullArticle] = useState(false);
  if (!article) return null;

  return (
    <>
      {showFullArticle && (
        <ArticleContentModal
          article={article}
          onClose={() => setShowFullArticle(false)}
          userRole={userRole}
        />
      )}
      <div
        className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4"
        onClick={onClose}
      >
        <div
          className="bg-white rounded-2xl w-full max-w-2xl max-h-[70vh] flex flex-col shadow-xl"
          onClick={(e) => e.stopPropagation()}
        >
        {/* Modal Header */}
        <div className="flex items-start justify-between p-4 border-b border-gray-100">
          <div className="flex-1 min-w-0 pr-3">
            <h3 className="font-semibold text-base text-gray-900 leading-snug mb-2">
              {article.titleKr || article.title}
            </h3>
            <div className="flex items-center gap-2 text-sm text-gray-500 flex-wrap">
              {article.ticker && (
                <>
                  <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded font-semibold">
                    {article.ticker}
                  </span>
                  <span className="text-gray-300">•</span>
                </>
              )}
              <div className="flex items-center gap-1">
                <Clock className="w-4 h-4" />
                <span>
                  {new Date(article.publishedAt).toLocaleDateString('ko-KR', {
                    month: 'short',
                    day: 'numeric'
                  })}
                </span>
              </div>
              {article.source && (
                <>
                  <span className="text-gray-300">•</span>
                  <span className={article.isOfficialSource ? 'text-green-600 font-semibold' : ''}>
                    {article.isOfficialSource ? '🏢 공식' : article.source}
                  </span>
                </>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Modal Content - Summary */}
        <div className="flex-1 overflow-y-auto p-5">
          <div className="space-y-4">
            {article.summaryKr ? (
              <div>
                <h4 className="text-sm font-semibold text-gray-500 mb-2 flex items-center gap-1">
                  <span>📝</span> 한국어 요약
                  {article.aiProcessed && (
                    <span className="text-xs text-green-600">(AI 처리함)</span>
                  )}
                </h4>
                <p className="text-base text-gray-700 leading-relaxed whitespace-pre-wrap">
                  {article.summaryKr}
                </p>
              </div>
            ) : (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <h4 className="text-sm font-semibold text-yellow-900 mb-2">
                  ⚠️ 한국어 요약 없음
                </h4>
                <p className="text-xs text-yellow-800">
                  요약 정보가 없습니다.
                </p>
              </div>
            )}

            {article.summaryEn && (
              <div className="pt-4 border-t border-gray-100">
                <h4 className="text-sm font-semibold text-gray-500 mb-2 flex items-center gap-1">
                  <span>📄</span> English Summary
                </h4>
                <p className="text-base text-gray-600 leading-relaxed whitespace-pre-wrap">
                  {article.summaryEn}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="p-4 border-t border-gray-100 flex justify-between items-center gap-2">
          <button
            onClick={() => {
              setShowFullArticle(true);
              if (onViewOriginal) onViewOriginal();
            }}
            className="flex-1 flex items-center justify-center gap-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
          >
            <FileText className="w-4 h-4" />
            전체 기사 보기
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
    </>
  );
}
